<div
  class="box-wrapper size-{{ size }} shadow-{{ shadow }} arrow-{{
    arrow
  }} arrowPosition-{{ arrowPosition }} shadowType-{{ shadowType }}"
>
  <ng-content></ng-content>
</div>
